import AddressFormSFC from "./AddressForm.vue";
export const AddressForm = AddressFormSFC;
